export const refs = {
  scrollBtn: document.querySelector('.js-scroll-btn'),
  menuBtn: document.querySelector('.js-menu-open'),
  mobileMenu: document.querySelector('.js-mob-menu'),
  closeBtn: document.querySelector('.js-mob-menu-close'),
  menuLinks: document.querySelectorAll('.js-link-mob-menu'),
  modal: document.querySelector('.js-backdrop-modal'),
  acceptBtn: document.querySelector('.js-btn-accept'),
  declineBtn: document.querySelector('.js-btn-decline'),
};
